module.exports = __webpack_public_path__ + "ed5f8855217b417b250bd135d18bef34.png";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/Der-Senator-fur-Kultur.png
// module id = 938
// module chunks = 0